<div class="card admin-card">
   <div
      class="card-head"
      style="margin-bottom: 20px">
      <div style="max-width: 50%">
         <div class="card-title">Deferral Requests</div>
         <div style="font-size: 13px; color: var(--muted); margin-top: 2px">
            Review and manage reviewees who have been deferred from an active cycle.
         </div>
      </div>

      <div
         class="admin-actions"
         style="margin-bottom: 16px">
         <input
            class="admin-search"
            [(ngModel)]="searchQuery"
            placeholder="Search deferred users..."
            (input)="applyFilters()" />

         <p-dropdown
            [(ngModel)]="roleFilter"
            (ngModelChange)="applyFilters()"
            [options]="userCycleOptions"
            placeholder="All cycles"
            ngModelOptions="{standalone: true}"
            [showClear]="true"
            name="roleFilter"></p-dropdown>

         <p-dropdown
            [(ngModel)]="userHospitalFilter"
            (ngModelChange)="applyFilters()"
            [options]="hospitalOptions"
            ngModelOptions="{standalone: true}"
            name="userHospitalFilter"
            [showClear]="true"
            placeholder="All hospitals"
            [filter]="true"
            class="practice-search"
            style="min-width: 250px"></p-dropdown>

         <p-dropdown
            [(ngModel)]="statusFilter"
            (ngModelChange)="applyFilters()"
            [options]="userDeferredOptions"
            placeholder="All statuses"
            ngModelOptions="{standalone: true}"
            [showClear]="true"
            name="statusFilter"></p-dropdown>
      </div>
   </div>

   <div
      class="loading"
      *ngIf="loading">
      Loading deferral requests…
   </div>

   <ng-container *ngIf="!loading">
      <div class="um-stat-row">
         <div class="um-stat-tile">
            <div class="um-stat-value">{{ totalDeferred }}</div>
            <div class="um-stat-label">Total deferred</div>
         </div>
         <div class="um-stat-tile">
            <div class="um-stat-value">{{ pendingCount }}</div>
            <div class="um-stat-label">Pending review</div>
         </div>
         <div class="um-stat-tile">
            <div class="um-stat-value">{{ reEnabledCount }}</div>
            <div class="um-stat-label">Re-enabled</div>
         </div>
      </div>

      <!--<div
         class="um-alert-banner"
         *ngIf="recentDeferralCount > 0">
         <i class="fas fa-exclamation-triangle"></i>
         {{ recentDeferralCount }} deferral{{ recentDeferralCount === 1 ? "" : "s" }} were logged in the last 24 hours —
         <a (click)="navigateToAuditLog.emit()">see Audit Log for details.</a>
      </div>-->

      <table class="admin-tbl defer-tbl">
         <thead>
            <tr>
               <th></th>
               <th
                  (click)="setUserSort('revieweeName')"
                  style="cursor: pointer; user-select: none">
                  Reviewee
                  <span *ngIf="sortColumn === 'revieweeName'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
               </th>
               <th
                  (click)="setUserSort('hireDate')"
                  style="cursor: pointer; user-select: none">
                  Hire Date
                  <span *ngIf="sortColumn === 'hireDate'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
               </th>
               <th
                  (click)="setUserSort('hospitalName')"
                  style="cursor: pointer; user-select: none">
                  Hospital
                  <span *ngIf="sortColumn === 'hospitalName'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
               </th>
               <th>Reason</th>
               <th
                  (click)="setUserSort('cycle')"
                  style="cursor: pointer; user-select: none">
                  Cycle
                  <span *ngIf="sortColumn === 'cycle'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
               </th>
               <th
                  (click)="setUserSort('role')"
                  style="cursor: pointer; user-select: none">
                  Job Code/Role
                  <span *ngIf="sortColumn === 'role'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
               </th>

               <th
                  (click)="setUserSort('dateDeferred')"
                  style="cursor: pointer; user-select: none">
                  Date Deferred
                  <span *ngIf="sortColumn === 'dateDeferred'">{{ sortDir === "asc" ? "↑" : "↓" }}</span>
               </th>
               <th>
                  Status
                  <div class="chips-row">
                     <mat-chip-listbox
                        multiple
                        [(ngModel)]="selectedStatusFilters"
                        (change)="onStatusChipChange($event)">
                        <mat-chip-option
                           value="Pending"
                           title="Pending"
                           class="pending-chip">
                           <i class="fa fa-clock"></i>
                        </mat-chip-option>
                        <mat-chip-option
                           value="Approved"
                           title="Approved"
                           class="approved-chip">
                           <i class="fa fa-check"></i>
                        </mat-chip-option>
                        <mat-chip-option
                           value="Rejected"
                           title="Rejected"
                           class="rejected-chip">
                           <i class="fa fa-close"></i>
                        </mat-chip-option>
                        <mat-chip-option
                           value="ReEnabled"
                           title="Re-Enabled"
                           class="reenabled-chip">
                           <i class="fa fa-undo"></i>
                        </mat-chip-option>
                     </mat-chip-listbox>
                  </div>
               </th>
               <th></th>
            </tr>
         </thead>
         <tbody>
            <ng-container *ngFor="let req of filteredRequests; trackBy: trackByReqId">
               <tr [style.background]="req.isFlagged ? '#fcf8f2' : '#ffffff'">
                  <td>
                     <button
                        type="button"
                        class="defer-flag-btn"
                        [class.is-flagged]="req.isFlagged"
                        [disabled]="req.flagSaving"
                        [attr.aria-pressed]="!!req.isFlagged"
                        [title]="req.isFlagged ? 'Remove flag' : 'Flag this request'"
                        (click)="toggleFlag(req, $event)">
                        <i [class]="req.isFlagged ? 'fas fa-flag' : 'far fa-flag'"></i>
                     </button>
                  </td>
                  <td>
                     <div class="name-cell">
                        <div
                           class="av"
                           [style.background]="getAvatarBg(req.revieweeName)"
                           [style.color]="getAvatarColor(req.revieweeName)">
                           {{ getInitials(req.revieweeName) }}
                        </div>
                        {{ req.revieweeName }}
                     </div>
                  </td>
                  <td>{{ req.hireDate | date: "MMM d, yyyy" }}</td>
                  <td>{{ req.hospitalName }}</td>
                  <td>{{ req.deferReason }}</td>

                  <td style="white-space: nowrap">
                     <span
                        *ngIf="getUserCycleDisplay(req)"
                        class="um-role-chip">
                        {{ getUserCycleDisplay(req) }}
                     </span>
                     <span
                        *ngIf="!getUserCycleDisplay(req)"
                        class="um-role-chip">
                        TEAM
                     </span>
                  </td>
                  <td>
                     <span style="color: #888">{{ req.role }}</span>
                  </td>

                  <td style="white-space: pre-line">{{ formatDate(req.dateDeferred) }}</td>
                  <td>
                     <span
                        class="defer-status-badge"
                        [ngClass]="getStatusBadgeClass(req.status)">
                        {{ getStatusLabel(req.status) }}
                     </span>
                  </td>
                  <td>
                     <div
                        class="defer-action-group"
                        *ngIf="req.status === 'Pending' || req.status === 'ReEnabled' || req.status === 'Rejected'">
                        <button
                           class="v-button v-button-sm v-orange"
                           style="padding: 5px 12px; background: #f7682a !important"
                           alt="Approve"
                           title="Approve"
                           [disabled]="req.saving || req.status != 'Pending'"
                           (click)="openRejectApproveDialog(req, 'approve')">
                           <i class="fa fa-check"></i>
                        </button>
                        <button
                           class="v-button v-button-sm v-blue"
                           style="padding: 5px 12px; position: relative"
                           alt="Follow-up"
                           title="Follow-up"
                           [style.opacity]="req.fuOpacity"
                           [disabled]="req.saving"
                           (click)="openFollowUpDialog(req)">
                           <i class="fa fa-comments"></i>
                           <span
                              *ngIf="req.unreadCount > 0"
                              class="fu-unread-badge">
                              {{ req.unreadCount }}
                           </span>
                        </button>
                        <button
                           class="v-button v-button-sm v-red"
                           style="padding: 5px 12px; background: #da3d3d !important; border-color: #da3d3d !important"
                           alt="Reject"
                           title="Reject"
                           [disabled]="req.saving || req.status != 'Pending'"
                           (click)="openRejectApproveDialog(req, 'reject')">
                           <i class="fa fa-close"></i>
                        </button>
                     </div>

                     <div
                        class="defer-action-group"
                        *ngIf="req.status === 'Deferred' || req.status === 'Approved'">
                        <button
                           class="v-button v-button-sm v-gray-border defer-reenable-btn"
                           [disabled]="req.saving"
                           (click)="reEnableUser(req)">
                           {{ req.saving ? "…" : "Re-enable" }}
                        </button>
                        <button
                           class="v-button v-button-sm v-blue"
                           style="padding: 5px 12px; position: relative"
                           alt="Follow-up"
                           title="Follow-up"
                           [style.opacity]="req.fuOpacity"
                           [disabled]="req.saving"
                           (click)="openFollowUpDialog(req)">
                           <i class="fa fa-comments"></i>
                           <span
                              *ngIf="req.unreadCount > 0"
                              class="fu-unread-badge">
                              {{ req.unreadCount }}
                           </span>
                        </button>
                     </div>

                     <!-- No action available -->
                     <!--<span
                     *ngIf="req.status === 'ReEnabled' || req.status === 'Rejected'"
                     class="defer-no-action">
                     —
                  </span>-->
                  </td>
               </tr>
            </ng-container>
            <tr *ngIf="filteredRequests.length === 0">
               <td
                  colspan="7"
                  class="muted"
                  style="padding: 24px; text-align: center">
                  No deferral requests match the current filters.
               </td>
            </tr>
         </tbody>
      </table>
   </ng-container>

   <div
      class="admin-success"
      *ngIf="actionSuccess">
      {{ actionSuccess }}
   </div>
   <div
      class="admin-error"
      *ngIf="actionError">
      {{ actionError }}
   </div>
</div>

<!-- Reject/Approve reason dialog -->
<div
   class="um-dialog-backdrop"
   *ngIf="rejectApproveDialogRequest"
   (click)="closeRejectApproveDialog()"></div>
<div
   class="um-dialog fu-dialog"
   *ngIf="rejectApproveDialogRequest">
   <div class="fu-header">
      <div class="fu-header-info">
         <div class="fu-title">
            {{ deferDialogType == "approve" ? "Approve" : "Reject" }} Deferral Request for {{ rejectApproveDialogRequest.revieweeName }}
         </div>
         <div class="fu-subtitle">{{ rejectApproveDialogRequest.hospitalName }}</div>
      </div>
      <div class="fu-header-right">
         <button
            class="rp-modal-close"
            (click)="closeRejectApproveDialog()"
            title="Close">
            ✕
         </button>
      </div>
   </div>

   <div class="fu-body">
      <textarea
         class="defer-textarea"
         *ngIf="deferDialogType == 'reject'"
         [(ngModel)]="rejectReason"
         placeholder="Enter reason (optional)"
         rows="4"></textarea>

      <span
         class="defer-prompt mt-2"
         style="margin-bottom: -10px">
         Would you like to move {{ rejectApproveDialogRequest.revieweeName }} to the OPEN cycle?
      </span>
      <vc-radio-group
         [(ngModel)]="moveDeferredToOpenCycle"
         direction="row"
         [required]="true"
         [yesno]="true"
         [options]="[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
         ]"></vc-radio-group>

      <span
         class="defer-prompt"
         [style.opacity]="!moveDeferredToOpenCycle ? '0.4' : '1'"
         style="margin-bottom: -10px">
         When Should This Review be Completed?
      </span>
      <div class="defer-quarter-strip">
         <div
            class="defer-quarter-option"
            [class.selected]="!deferQuarter"
            [class.disabled]="!moveDeferredToOpenCycle"
            (click)="selectDeferQuarter(null)">
            <div class="defer-quarter-label">Unsure</div>
         </div>
         <div
            *ngFor="let q of deferQuarterOptions"
            class="defer-quarter-option"
            [class.selected]="deferQuarter === q.value"
            [class.disabled]="!moveDeferredToOpenCycle"
            (click)="selectDeferQuarter(q.value)">
            <div class="defer-quarter-label">
               {{ q.label }}
            </div>
            <div class="defer-quarter-sub">
               {{ q.sub }}
            </div>
         </div>
      </div>
   </div>

   <div class="fu-footer">
      <div
         class="fu-footer-buttons"
         style="align-self: end">
         <button
            class="v-button v-button-md v-gray"
            (click)="closeRejectApproveDialog()">
            Cancel
         </button>
         <button
            class="v-button v-button-md"
            [class.v-red]="deferDialogType == 'reject'"
            [class.v-green]="deferDialogType == 'approve'"
            [disabled]="rejectApproveDialogRequest.saving"
            (click)="deferDialogType == 'approve' ? approveRequest() : confirmReject()">
            {{ rejectApproveDialogRequest.saving ? "…" : deferDialogType == "reject" ? "Reject" : "Approve" }}
         </button>
      </div>
   </div>
</div>

<!-- Follow-up chat dialog -->
<div
   class="um-dialog-backdrop"
   *ngIf="followUpDialogRequest"
   (click)="closeFollowUpDialog()"></div>
<div
   class="um-dialog fu-dialog"
   *ngIf="followUpDialogRequest">
   <div class="fu-header">
      <div class="fu-header-info">
         <div class="fu-title">Follow-up for {{ followUpDialogRequest.revieweeName }}</div>
         <div class="fu-subtitle">{{ followUpDialogRequest.hospitalName }}</div>
      </div>
      <div class="fu-header-right">
         <span
            class="fu-flag-badge"
            *ngIf="followUpDialogRequest.isFlagged">
            <i class="fa fa-flag"></i>
            Flagged
         </span>
         <button
            class="rp-modal-close"
            (click)="closeFollowUpDialog()"
            title="Close">
            ✕
         </button>
      </div>
   </div>

   <div class="fu-body">
      <div
         class="loading"
         *ngIf="followUpLoading">
         Loading messages…
      </div>
      <ng-container *ngIf="!followUpLoading">
         <div class="fu-message fu-message--user">
            <div class="fu-message-avatar fu-message-avatar--user">
               <i class="fa fa-user"></i>
            </div>
            <div class="fu-message-content">
               <div class="fu-message-meta">
                  <span class="fu-message-author">{{ followUpDialogRequest.deferredByName }}</span>
                  <span class="fu-message-time">{{ followUpDialogRequest.dateDeferred | date: "M/d/yyyy h:mm a" }}</span>
               </div>
               <div class="fu-message-bubble fu-message-bubble--user">
                  {{ followUpDialogRequest.deferReason || "No reason provided." }}
               </div>
            </div>
         </div>

         <div
            *ngFor="let msg of followUpMessages"
            [class]="msg.isAdmin ? 'fu-message fu-message--admin' : 'fu-message fu-message--user-reply'">
            <div [class]="msg.isAdmin ? 'fu-message-avatar fu-message-avatar--admin' : 'fu-message-avatar fu-message-avatar--user'">
               <i [class]="msg.isAdmin ? 'fa fa-hospital-user' : 'fa fa-user'"></i>
            </div>
            <div class="fu-message-content">
               <div class="fu-message-meta">
                  <span class="fu-message-author">{{ msg.sentByName }}</span>
                  <span class="fu-message-time">{{ msg.sentOn | date: "M/d/yyyy h:mm a" }}</span>
               </div>
               <div [class]="msg.isAdmin ? 'fu-message-bubble fu-message-bubble--admin' : 'fu-message-bubble fu-message-bubble--user'">
                  {{ msg.message }}
               </div>
            </div>
         </div>

         <div class="fu-private-section">
            <div class="fu-private-divider">
               <div>
                  <span class="fu-private-divider-title">
                     <i class="fa fa-lock"></i>
                     Private conversations
                  </span>
                  <span class="fu-private-note">ADMIN ONLY · Not visible to the requester</span>
               </div>

               <button
                  type="button"
                  class="fu-private-add-btn"
                  *ngIf="!privateAskOpen"
                  (click)="openPrivateQuestionComposer()">
                  <i class="fa fa-user-plus"></i>
                  Open Private Conversation
               </button>
            </div>

            <!-- Start a new one-to-one private conversation -->
            <div
               class="fu-private-ask-card"
               *ngIf="privateAskOpen">
               <div class="fu-private-ask-title">Open a private conversation with another user</div>
               <div class="fu-private-ask-copy">Only you and the person you select will be added to this conversation.</div>

               <div class="fu-private-user-search">
                  <label class="fu-private-field-label">USER</label>
                  <div class="fu-private-autocomplete-wrap">
                     <input
                        class="fu-private-user-input"
                        [(ngModel)]="privateUserSearchQuery"
                        (input)="onPrivateUserSearchInput()"
                        (focus)="onPrivateUserSearchInput()"
                        (blur)="onPrivateSearchBlur()"
                        placeholder="Search for a user…"
                        autocomplete="off" />

                     <button
                        type="button"
                        class="fu-private-input-clear"
                        *ngIf="selectedPrivateUser"
                        (click)="clearPrivateUser()"
                        title="Clear">
                        ✕
                     </button>

                     <div
                        class="fu-private-selected-user"
                        *ngIf="selectedPrivateUser">
                        <div
                           class="av av-sm"
                           [style.background]="getAvatarBg(selectedPrivateUser.displayName)"
                           [style.color]="getAvatarColor(selectedPrivateUser.displayName)">
                           {{ getInitials(selectedPrivateUser.displayName) }}
                        </div>
                        <span>{{ selectedPrivateUser.displayName }}</span>
                     </div>

                     <div
                        class="fu-private-autocomplete-dropdown"
                        *ngIf="showPrivateUserDropdown && privateUserSearchResults.length > 0">
                        <div
                           class="fu-private-autocomplete-item"
                           *ngFor="let u of privateUserSearchResults"
                           (mousedown)="selectPrivateUser(u)">
                           <div
                              class="av av-sm"
                              [style.background]="getAvatarBg(u.displayName)"
                              [style.color]="getAvatarColor(u.displayName)">
                              {{ getInitials(u.displayName) }}
                           </div>
                           <span>{{ u.displayName }}</span>
                        </div>
                     </div>

                     <div
                        class="fu-private-autocomplete-dropdown fu-private-autocomplete-empty"
                        *ngIf="privateSearchLoading">
                        Searching…
                     </div>

                     <div
                        class="fu-private-autocomplete-dropdown fu-private-autocomplete-empty"
                        *ngIf="
                           showPrivateUserDropdown &&
                           privateUserSearchQuery.length >= 2 &&
                           !privateSearchLoading &&
                           privateUserSearchResults.length === 0
                        ">
                        No users found matching "{{ privateUserSearchQuery }}"
                     </div>
                  </div>
               </div>

               <label class="fu-private-field-label">QUESTION</label>
               <textarea
                  class="fu-private-question-input"
                  [(ngModel)]="privateQuestion"
                  placeholder="Ask a private question about this deferral…"
                  rows="3"></textarea>

               <div class="fu-private-ask-actions">
                  <button
                     type="button"
                     class="v-button v-button-md v-gray"
                     (click)="closePrivateQuestionComposer()">
                     Cancel
                  </button>
                  <button
                     type="button"
                     class="v-button v-button-md v-teal"
                     style="background: #734e00; border-color: #734e00"
                     [disabled]="!selectedPrivateUser || !privateQuestion?.trim() || privateQuestionSending"
                     (click)="sendPrivateQuestion()">
                     <i class="fa fa-paper-plane"></i>
                     &nbsp;{{ privateQuestionSending ? "Sending…" : "Send privately" }}
                  </button>
               </div>
            </div>

            <div
               class="fu-private-loading"
               *ngIf="privateAdminLoading">
               Loading private conversations…
            </div>

            <ng-container *ngIf="!privateAdminLoading">
               <div
                  class="fu-private-empty"
                  style="text-align: center"
                  *ngIf="privateAdminThreads.length === 0 && !privateAskOpen">
                  Rope another user into this deferral privately.
               </div>

               <div class="fu-private-thread-container">
                  <div
                     class="fu-private-thread"
                     *ngFor="let thread of privateAdminThreads">
                     <div class="fu-private-thread-head">
                        <div style="width: 100%">
                           <div class="fu-private-context">
                              <i class="fa fa-lock"></i>
                              &nbsp; Private thread with {{ getPrivateThreadPeople(thread) }}
                           </div>
                           <!--<div
                           class="fu-private-context-sub"
                           *ngIf="thread.contextLabel">
                           {{ thread.contextLabel }}
                        </div>-->
                        </div>
                     </div>

                     <div
                        class="fu-message fu-message--private"
                        [class.fu-message--private-mine]="msg.isMine"
                        *ngFor="let msg of thread.messages">
                        <div class="fu-message-avatar fu-message-avatar--private">
                           <i class="fa fa-lock"></i>
                        </div>
                        <div class="fu-message-content">
                           <div class="fu-message-meta">
                              <span class="fu-message-author">{{ msg.isMine ? "You" : msg.sentByName }}</span>
                              <span class="fu-message-time">{{ msg.sentOn | date: "M/d/yyyy h:mm a" }}</span>
                              <span class="fu-private-chip">Private</span>
                           </div>
                           <div class="fu-message-bubble fu-message-bubble--private">
                              {{ msg.message }}
                           </div>
                        </div>
                     </div>

                     <div class="fu-private-reply-row">
                        <input
                           class="fu-private-reply-input"
                           [(ngModel)]="privateReplyText[thread.id]"
                           (keyup.enter)="sendPrivateReply(thread)"
                           [placeholder]="'Reply privately to ' + getPrivateThreadPeople(thread) + '…'" />
                        <button
                           type="button"
                           class="fu-private-reply-btn"
                           [disabled]="!privateReplyText[thread.id]?.trim() || privateReplySending[thread.id]"
                           (click)="sendPrivateReply(thread)">
                           <i class="fa fa-paper-plane"></i>
                           {{ privateReplySending[thread.id] ? "Sending…" : "Send" }}
                        </button>
                     </div>
                  </div>
               </div>
            </ng-container>
         </div>

         <!--<div
            class="fu-empty"
            *ngIf="followUpMessages.length === 0">
            No HM-visible follow-up messages yet. Write a response below if you want to reply to the requester.
         </div>-->
      </ng-container>
   </div>

   <div class="fu-footer">
      <div class="fu-reply-visibility">
         <i class="fa fa-eye"></i>
         This reply is part of the deferral conversation and is visible to the requester.
      </div>
      <textarea
         class="fu-textarea"
         [(ngModel)]="followUpMessage"
         placeholder="Write a response…"
         rows="3"></textarea>
      <div class="fu-footer-actions">
         <button
            type="button"
            class="fu-flag-toggle"
            [class.is-flagged]="followUpDialogRequest.isFlagged"
            [disabled]="followUpDialogRequest.flagSaving"
            [title]="followUpDialogRequest.isFlagged ? 'Remove flag' : 'Flag this request'"
            (click)="toggleFlag(followUpDialogRequest)">
            <i [class]="followUpDialogRequest.isFlagged ? 'fas fa-flag' : 'far fa-flag'"></i>
            {{ followUpDialogRequest.isFlagged ? "Remove flag" : "Flag this request" }}
         </button>

         <div class="fu-footer-buttons">
            <button
               class="v-button v-button-md v-gray"
               (click)="closeFollowUpDialog()">
               Cancel
            </button>
            <button
               class="v-button v-button-md v-teal"
               [disabled]="!followUpMessage?.trim() || followUpSaving"
               (click)="sendFollowUp()">
               {{ followUpSaving ? "Sending…" : "Send" }}
            </button>
         </div>
      </div>
   </div>
</div>
